var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadNoFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#006dc9",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.895 10.73v2.896c0 .058-.009.112-.022.161-.061.284-.328.499-.643.499H.66c-.336 0-.616-.243-.651-.552C0 13.696 0 13.664 0 13.622v-2.897c0-.342.298-.618.656-.618.18 0 .346.07.464.181.118.112.193.268.193.437v2.32h11.274v-2.32c0-.342.297-.618.656-.618.18 0 .346.07.464.181.114.116.188.273.188.441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.776 7.362l-3.22 3.385c-.004.01-.013.014-.017.019-.118.124-.271.202-.424.225-.013 0-.026.004-.04.004C7.05 11 7.024 11 6.998 11l-.074-.005c-.013 0-.026-.004-.04-.004-.157-.023-.305-.101-.423-.225l-.018-.019-3.22-3.385C3.075 7.206 3 7 3 6.792c0-.206.074-.412.223-.569.297-.312.782-.312 1.083 0l1.935 2.035V.804c0-.441.345-.804.765-.804.21 0 .402.092.541.234.14.147.223.345.223.57v7.454l1.935-2.035c.297-.312.782-.312 1.084 0 .284.317.284.827-.013 1.14"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadNoFill);
export default __webpack_public_path__ + "static/media/download-no-fill.621eb97bb4dcf566897fd6ccf0cb5357.svg";
export { ForwardRef as ReactComponent };